module.exports = __webpack_public_path__ + "static/img/search-man.77fcee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search-man.png
// module id = lCiF
// module chunks = 3